import React from 'react';
import { ATMGrid, ATMSegment } from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { AccessType } from 'src/constants';
import { hasAccess } from 'src/libraries/access.library';
import Tabs from 'src/components/atoms/tabs/tabs.component';
import RopeSizeConductor from '../rope-size-conductor/rope-size-conductor-list/rope-size-conductor-list.component';
import FlightTypes from '../flight-types/flight-types-list/flight-types-list.component';
import TailNumbers from '../tail-numbers/tail-numbers-list/tail-numbers-list.component';
import Pilots from '../pilots/pilots-list/pilots-list.component';
import FireAgencies from '../fire-agencies/fire-agencies-list/fire-agencies-list.component';
import FlightOperators from '../flight-operators/flight-operators-list/flight-operators-list.component';
import RoleMaintenance from '../role-maintenance/role-maintenance-list/role-maintenance-list.component';
import ConfigurationSettingsList from '../configuration-settings/configuration-settings-list/configuration-settings-list.component';
import OperatorPilotList from '../operator-pilot-relationship/operator-pilot-relationship-list/operator-pilot-relationship-list.component';
import OperatorTailList from '../operator-tail-number-relationship/operator-tail-number-relationship-list/operator-tail-number-relationship-list.component';
import DistrictList from '../district/district-list/district-list.component';
import Polygons from '../polygons/polygon-list/polygons-list.component';
import SensitiveCities from '../sensitive-cities/sensitive-cities-list/sensitive-cities-list.component';
import SensitiveCommunities from '../sensitive-communities/sensitive-communities-list/sensitive-communities-list.component';
import DroneAreas from '../drone-Areas/drone-areas-list/drone-areas-list.component';

const AdminMenu: React.FC = () => {
  let panes = [
    {
      menuItem: Lang.TTL_ADMIN_FLIGHT_TYPES,
      render: () => (
        <ATMSegment>
          <FlightTypes />
        </ATMSegment>
      ),
    },
    {
      menuItem: Lang.TTL_ADMIN_SENSITIVE_CITIES,
      render: () => (
        <ATMSegment>
           <SensitiveCities />
        </ATMSegment>
      ),
    },
    {
      menuItem: Lang.TTL_ADMIN_SENSITIVE_COMMUNITIES,
      render: () => (
        <ATMSegment>
           <SensitiveCommunities />
        </ATMSegment>
      ),
    },
    {
      menuItem: Lang.TTL_ADMIN_DRONE_AREAS,
      render: () => (
        <ATMSegment>
          <DroneAreas />
        </ATMSegment>
      ),
    },
    {
      menuItem: Lang.TTL_ADMIN_FLIGHT_OPERATORS,
      render: () => (
        <ATMSegment>
          <FlightOperators />
        </ATMSegment>
      ),
    },
    {
      menuItem: Lang.TTL_ADMIN_TAIL_NUMBERS,
      render: () => (
        <ATMSegment>
          <TailNumbers />
        </ATMSegment>
      ),
    },
    {
      menuItem: Lang.TTL_ADMIN_DISTRICT_PROJECTS,
      render: () => (
        <ATMSegment>
          <DistrictList />
        </ATMSegment>
      ),
    },
    {
      menuItem: Lang.TTL_ADMIN_PILOTS,
      render: () => (
        <ATMSegment>
          <Pilots />
        </ATMSegment>
      ),
    },
    {
      menuItem: Lang.TTL_ADMIN_OPERATORS_AND_PILOTS,
      render: () => (
        <ATMSegment>
          <OperatorPilotList />
        </ATMSegment>
      ),
    },
    {
      menuItem: Lang.TTL_ADMIN_OPERATORS_AND_TAILS,
      render: () => (
        <ATMSegment>
          <OperatorTailList />
        </ATMSegment>
      ),
    },
    {
      menuItem: Lang.TTL_ADMIN_FIRE_AGENCIES,
      render: () => (
        <ATMSegment>
          <FireAgencies />
        </ATMSegment>
      ),
    },
    {
      menuItem: Lang.TTL_ADMIN_ROPE_SIZE_AND_CONDUCTORS,
      render: () => (
        <ATMSegment>
          <RopeSizeConductor />
        </ATMSegment>
      ),
    },
    {
      menuItem: Lang.TTL_ADMIN_POLYGON,
      render: () => (
        <ATMSegment>
          <Polygons />
        </ATMSegment>
      ),
    },
  ];

  // for UT Coverage
  if (process.env.REACT_APP_SWITCH_TO_UNIT_TEST_MODE === 'true') {
    panes[0].render();
    panes[1].render();
    panes[2].render();
    panes[3].render();
    panes[4].render();
    panes[5].render();
    panes[6].render();
    panes[7].render();
    panes[8].render();
    panes[9].render();
  }

  // Checks if the logged in user has access to these types
  if (hasAccess([AccessType.ROLE_MANAGER_READ, AccessType.SETTING_READ])) {
    panes = [
      {
        menuItem: Lang.TTL_ADMIN_ROLE_MAINTENANCE,
        render: () => (
          <ATMSegment>
            <RoleMaintenance />
          </ATMSegment>
        ),
      },
      {
        menuItem: Lang.TTL_ADMIN_CONFIGURATION_SETTINGS,
        render: () => (
          <ATMSegment>
            <ConfigurationSettingsList />
          </ATMSegment>
        ),
      },
      ...panes,
    ];
  }

  // for UT Coverage
  if (process.env.REACT_APP_SWITCH_TO_UNIT_TEST_MODE === 'true') {
    panes[0].render();
    panes[1].render();
  }

  return (
    <ATMGrid>
      <ATMGrid.Column>
        <Tabs menu={{ fluid: true, vertical: true }} panes={panes} />
      </ATMGrid.Column>
    </ATMGrid>
  );
};

export default AdminMenu;
